module.exports = __webpack_public_path__ + "static/media/ic_map.b5eef698.svg";